import { FirebaseOptions, getApps, initializeApp } from "firebase/app";
import {
  Analytics,
  initializeAnalytics,
  isSupported,
  logEvent,
} from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { createConfig } from "./Config";

const config = createConfig();

const firebaseOptions: FirebaseOptions = {
  apiKey: config.firebaseApiKey,
  authDomain: config.firebaseAuthDomain,
  projectId: config.firebaseProjectId,
  appId: config.firebaseAppId,
  measurementId: config.firebaseMeasurementId,
  messagingSenderId: config.firebaseMessagingSenderId,
  storageBucket: config.firebaseStorageBucket,
};

export const isFirebaseConfigured = Boolean(
  firebaseOptions.apiKey &&
    firebaseOptions.authDomain &&
    firebaseOptions.projectId
);

const app = isFirebaseConfigured
  ? getApps()[0] ?? initializeApp(firebaseOptions)
  : null;

export const firebaseAuth = app ? getAuth(app) : null;
export const firebaseAnalytics: Promise<Analytics | null> = app
  ? isSupported().then((supported) =>
      supported
        ? initializeAnalytics(app, { config: { send_page_view: false } })
        : null
    )
  : Promise.resolve(null);
export const googleAuthProvider = new GoogleAuthProvider();

export async function logPageView(path: string) {
  const analytics = await firebaseAnalytics;
  if (!analytics) {
    return;
  }

  logEvent(analytics, "page_view", {
    page_location: window.location.href,
    page_path: path,
    page_title: document.title,
  });
}
